<ng-container *ngIf="!fieldTemplate; else customTemplate">
    <ng-container *ngIf="(field.selectData.options | async) || ['loading'] as options">
        <div [id]="field.field + '_Item'" class="inputItem"
             *ngIf="(options | filterOptions : field.selectData?.labelKeys : selectFilter[field.field] : field.selectData?.separator) as filteredOptions">
            <mat-form-field appearance="fill" #item [color]="field.color" [style.pointer-events]="field.readonly ? 'none' : 'inherit'">
                <mat-label [class]="field.field + '_Label'">{{ field.label | translate }}</mat-label>
                <mat-select [formControl]="inputFormControl" [multiple]="field.type === 'multiselect'" (openedChange)="selectFilter[field.field] = null; field.selectData?.autofocus ? inputEl?.nativeElement?.focus() : null;">
                    <div *ngIf="field.selectData?.displaySearch" class="selectSearch">
                        <mat-checkbox *ngIf="field.type === 'multiselect'"
                                      class="searchToggle"
                                      (change)="masterToggle($event, field, options)"
                                      [checked]="options.length === inputFormControl.value?.length"
                                      [indeterminate]="inputFormControl.value?.length > 0 && options.length !== inputFormControl.value?.length"
                        ></mat-checkbox>
                        <mat-icon *ngIf="field.type === 'select'" class="searchIcon">search</mat-icon>
                        <input matInput type="text" [placeholder]="'sla-ui-material.search.label' | translate" class="searchInput" [ngModel]="selectFilter[field.field]"
                               (ngModelChange)="selectFilter[field.field] = $event || null" #inputEl
                               [ngModelOptions]="{ standalone: true }" autocomplete="off" (keydown)="$event.stopPropagation()" [autofocus]="field.selectData?.autofocus"/>
                        <button *ngIf="selectFilter[field.field]" class="searchClear" mat-icon-button aria-label="Clear" (click)="selectFilter[field.field] = null">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>

                    <mat-select-trigger>
                        <ng-container *ngIf="filteredOptions[0] !== 'loading'">
                            <ng-container
                                    *ngIf="(filteredOptions | filter: field.selectData.valueKey : ((inputFormControl?.valueChanges | async) || inputFormControl?.value)) as data">
                                {{ field.selectData | matGenericInputLabel: data : true }}
                            </ng-container>
                        </ng-container>
                    </mat-select-trigger>

                    <ng-container *ngIf="filteredOptions[0] !== 'loading'">
                        <mat-option *ngFor="let data of filteredOptions" [value]="data[field.selectData?.valueKey]" class="select-data-option">
                            <span [innerHTML]="field.selectData | matGenericInputLabel: data : true : true"></span>
                        </mat-option>
                    </ng-container>
                </mat-select>
                <div matSuffix class="matSuffix">
                    <button *ngIf="field.withClearButton" type="button" tabindex="-1" mat-icon-button (click)="$event.stopPropagation(); inputFormControl.patchValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-generic-input-slot [control]="inputFormControl" [field]="field" [fieldAddonTemplates]="fieldAddonTemplates$ | async"></mat-generic-input-slot>
                </div>
                <mat-error *ngIf="!((field.selectSearchData?.selectData?.options | async))?.length">
                    <mat-generic-input-hint type="error" [control]="inputFormControl" [field]="field" [item]="item"></mat-generic-input-hint>
                </mat-error>
                <mat-hint>
                    <mat-generic-input-hint type="combined" [control]="inputFormControl" [field]="field" [item]="item"></mat-generic-input-hint>
                </mat-hint>
            </mat-form-field>
            <mat-progress-bar mode="indeterminate" color="warning" *ngIf="options[0] === 'loading'"></mat-progress-bar>
            <mat-progress-bar class="loading" color="warning" mode="indeterminate"
                              *ngIf="(inputFormControl?.statusChanges | async) === 'PENDING' || inputFormControl?.status === 'PENDING'"></mat-progress-bar>
        </div>
    </ng-container>
</ng-container>

<ng-template #customTemplate>
    <ng-container *ngTemplateOutlet="fieldTemplate.template, context: { $implicit: field, genericInput: this, formControl: inputFormControl, index: index }"></ng-container>
</ng-template>
